import { render, staticRenderFns } from "./CommissionRateAdjustmentRuleForm.vue?vue&type=template&id=38c7efbb"
import script from "./CommissionRateAdjustmentRuleForm.vue?vue&type=script&lang=js"
export * from "./CommissionRateAdjustmentRuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports